import { Button, FileUploadOutlinedIcon } from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { useItemAnalysis } from '../../providers';
import { ItemAnalysisReportExportModal } from '../item-analysis-report-export-modal';

export default function ItemAnalysisReportExportButton() {
  const [isModalOpen, { open: openModal, close: closeModal }] = useDisclosure();

  const { questionAnalysisData } = useItemAnalysis();

  const totalCount = questionAnalysisData?.total ?? 0;
  const shouldDisable = totalCount === 0;

  const handleClick = () => {
    openModal();
  };

  return (
    <>
      <Button
        variant='outlined'
        color='secondary'
        startIcon={<FileUploadOutlinedIcon />}
        onClick={handleClick}
        disabled={shouldDisable}
      >
        Export
      </Button>
      <ItemAnalysisReportExportModal
        open={isModalOpen}
        onClose={closeModal}
        totalCount={totalCount}
      />
    </>
  );
}
